module.exports = __webpack_public_path__ + "img/myInitialEle.98af9091.svg";